<template>
    <section>
        Aqui
    </section>
</template>

<script>

export default {
  name: "top-product",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

</style>
